/**
 * Action flags for the screen_actions table (Layer 2a).
 *
 * Per SOP 15 Ch.17 Layer 2a (LOCKED 2026-05-13). Flat-boolean
 * columns on screen_actions; no reference table. Adding a 6th
 * flag is a migration + this constant edit + a UI column edit.
 *
 * ACTIONFLAGS defines the canonical iteration order for the UI
 * columns (left→right). ACTIONLABELS holds the human-readable
 * column header for each flag.
 */

export const ACTIONFLAGS = [
  'is_view',
  'is_add',
  'is_edit',
  'is_delete',
  'is_export'
] as const

export type ActionFlag = (typeof ACTIONFLAGS)[number]

export const ACTIONLABELS: Record<ActionFlag, string> = {
  is_view: 'View',
  is_add: 'Add',
  is_edit: 'Edit',
  is_delete: 'Delete',
  is_export: 'Export'
}
